import { useTranslation } from 'react-i18next'
import { Dialog } from 'primereact/dialog'
import Button from '../../../components/ui/Button'
import type { AgendaScope } from '../types'

interface Props {
  visible: boolean
  header: string
  message: string
  /** Silme: seçenekler yıkıcı tonda. */
  destructive?: boolean
  onChoose: (scope: AgendaScope) => void
  onHide: () => void
}

/**
 * Tekrarlı toplantıda kapsam seçimi (126, FR-010/FR-015): "Yalnız bu toplantı" / "Serinin tamamı". Vazgeçmek
 * başlıktaki ×, Esc ya da maske tıklamasıdır — uygulama kuralı gereği ayrı bir "Vazgeç" düğmesi yoktur
 * (bkz. `FormDialog`). PrimeReact `confirmDialog` iki ayrı "kabul" eylemi sunmadığı için ayrı bileşen.
 */
export default function SeriesScopeDialog({
  visible,
  header,
  message,
  destructive = false,
  onChoose,
  onHide,
}: Readonly<Props>) {
  const { t } = useTranslation()
  const severity = destructive ? 'danger' : undefined
  const footer = (
    <div className="ui-dialog-footer agenda-scope-footer">
      <Button
        variant="secondary"
        severity={severity}
        label={t('agenda.recurrence.scope.occurrence')}
        onClick={() => onChoose('OCCURRENCE')}
      />
      <Button severity={severity} label={t('agenda.recurrence.scope.series')} onClick={() => onChoose('SERIES')} />
    </div>
  )
  return (
    <Dialog
      visible={visible}
      header={header}
      footer={footer}
      onHide={onHide}
      modal
      blockScroll
      dismissableMask
      draggable={false}
      style={{ width: '30rem', maxWidth: '92vw' }}
    >
      <p className="agenda-scope-message">{message}</p>
      <p className="agenda-muted agenda-scope-hint">{t('agenda.recurrence.scope.seriesHint')}</p>
    </Dialog>
  )
}
